import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { ConfigLoader } from '@tc-core/util/framework';
import { of, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SetupGridComp } from '../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid-comp';
import { SetupGridComponent } from '../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid.component';
import { TCO } from '../../../constants';
import { RoomFacilitySearchCriteria } from '../../../models/criteria/room-facility-search-criteria';
import { SortDirection } from '../../../models/helper/sort-direction';
import { AccommodationService } from '../../../services/backend-consumers/setups/accommodation.service';
import { DataKey, DataStoreService } from '../../../services/util/framework/data-store.service';
var RoomFacilitySetupComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RoomFacilitySetupComponent, _super);
    function RoomFacilitySetupComponent(configLoader, dataStoreService, accommodationService) {
        var _this = _super.call(this) || this;
        _this.configLoader = configLoader;
        _this.dataStoreService = dataStoreService;
        _this.accommodationService = accommodationService;
        _this.colDefConfig = [];
        _this.roomFacilitySearchCriteria = new RoomFacilitySearchCriteria();
        // required options for grid editors
        // nothing
        _this.searchCriteriaObserver = new Subscription();
        _this.isDisableGeoClick = function (params) {
            return _this.checkRowInvalid(params.data);
        };
        return _this;
    }
    RoomFacilitySetupComponent.prototype.ngOnInit = function () {
        this.colDefConfig = this.configLoader.configurations.get(TCO.CONF.CONF_ROOM_FACILITY_SETUP);
        this.subscribeSearchCriteria();
    };
    /**
     * subscribe search criteria changes in search bar
     * then force grid to refresh data
     * grid refresh will be call getRaws method which is using this subscribed criteria for backend call
     */
    RoomFacilitySetupComponent.prototype.subscribeSearchCriteria = function () {
        var _this = this;
        this.searchCriteriaObserver = this.dataStoreService.get(DataKey.roomFacilitySearchCriteria)
            .subscribe(function (value) {
            _this.roomFacilitySearchCriteria = value;
            _this.setupGrid.runForceSearch();
        });
    };
    RoomFacilitySetupComponent.prototype.checkRowInvalid = function (data) {
        var event = {
            data: data
        };
        return this.isInvalidRow(event);
    };
    RoomFacilitySetupComponent.prototype.fillRequiredGridOptionData = function () {
        // nothing
    };
    RoomFacilitySetupComponent.prototype.fillDataKeyForEditorData = function () {
        // nothing
    };
    RoomFacilitySetupComponent.prototype.isInvalidRow = function (params) {
        var data = params.data;
        if (data) {
            var invalid = true;
            if (data.name) {
                invalid = false;
            }
            return invalid;
        }
        else {
            return false;
        }
    };
    RoomFacilitySetupComponent.prototype.createNewRow = function () {
        return { unsaved: true };
    };
    RoomFacilitySetupComponent.prototype.isUnsavedRow = function (row) {
        return !!row.unsaved;
    };
    RoomFacilitySetupComponent.prototype.deleteRow = function (row) {
        if (row && row.id) {
            return this.accommodationService.deleteRoomFacility(row.id);
        }
        else {
            return of('success');
        }
    };
    RoomFacilitySetupComponent.prototype.saveRow = function (row, event) {
        return this.accommodationService.saveRoomFacility(row)
            .pipe(tap(function (data) { return row.unsaved = undefined; }));
    };
    RoomFacilitySetupComponent.prototype.getRows = function (params) {
        var _this = this;
        this.dataStoreService.set(DataKey.roomFacilitySearchResultsForCriteria, null);
        var pageSize = 1000000;
        if (!this.roomFacilitySearchCriteria) {
            this.roomFacilitySearchCriteria = new RoomFacilitySearchCriteria();
        }
        this.roomFacilitySearchCriteria.start = params.startRow;
        this.roomFacilitySearchCriteria.size = pageSize;
        if (params.sortModel && params.sortModel[0]) {
            this.roomFacilitySearchCriteria.sortBy = params.sortModel[0].colId;
            if (params.sortModel[0].sort === SetupGridComp.GRID_SORT_ASCENDING) {
                this.roomFacilitySearchCriteria.sortDirection = SortDirection.ASC;
            }
            else {
                this.roomFacilitySearchCriteria.sortDirection = SortDirection.DESC;
            }
        }
        return this.accommodationService.getRoomFacilities(this.roomFacilitySearchCriteria)
            .pipe(tap(function (data) {
            return _this.dataStoreService.set(DataKey.roomFacilitySearchResultsForCriteria, data);
        }));
    };
    RoomFacilitySetupComponent.prototype.ngOnDestroy = function () {
        if (this.searchCriteriaObserver) {
            this.searchCriteriaObserver.unsubscribe();
        }
    };
    return RoomFacilitySetupComponent;
}(SetupGridComp));
export { RoomFacilitySetupComponent };
